// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  text-align: center;
}
.main-container img {
  width: 100%;
  padding: 1rem 0.5rem;
  display: block;
  margin: 0 auto;
}
.main-container mat-card-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.main-container mat-card-actions a {
  margin: 0.5rem 0 0;
  width: 100%;
  background-color: var(--dim-white);
}
.main-container h1 {
  font-size: 250%;
  text-align: center;
  color: var(--text-color);
}
.main-container div.title {
  width: 100%;
  padding: 0 !important;
  margin: 1rem 0;
  text-align: center;
  color: var(--text-color);
}
.main-container div.title h2 {
  color: white;
  font-size: 1.5rem;
  padding: 1.1rem;
  display: inline-block;
  margin: 0;
  background-color: var(--dark-blue);
  border-radius: 1rem;
}
.main-container div.sub-container {
  width: 100%;
  border-radius: 0.5rem;
  padding: 1rem !important;
  background-color: var(--accent-back);
  margin-bottom: 1rem !important;
}
.main-container ::ng-deep .mat-card-header-text {
  width: 100%;
}
.main-container mat-card-header {
  text-align: center;
}

@media only screen and (min-width: 1280px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 25%;
    max-width: 25%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 1279px) and (min-width: 960) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 33%;
    max-width: 33%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 959px) and (min-width: 600px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 50%;
    max-width: 50%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 599px) {
  .fxFlex-25-33md-50sm-100xs {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/supporters/supporters.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,WAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,WAAA;EACA,kCAAA;AAAN;AAIE;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;AAFJ;AAKE;EACE,WAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AAHJ;AAKI;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,SAAA;EACA,kCAAA;EACA,mBAAA;AAHN;AAOE;EACE,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,8BAAA;AALJ;AAQE;EACE,WAAA;AANJ;AASE;EACE,kBAAA;AAPJ;;AAaA;EAEE;IAEI,aAAA;IACA,cAAA;IACA,sBAAA;EAZJ;AACF;AAiBA;EAEE;IAEI,aAAA;IACA,cAAA;IACA,sBAAA;EAjBJ;AACF;AAuBA;EAEE;IAEI,aAAA;IACA,cAAA;IACA,sBAAA;EAvBJ;AACF;AA4BA;EAEE;IAEI,cAAA;IACA,eAAA;IACA,sBAAA;EA5BJ;AACF","sourcesContent":[".main-container {\r\n  text-align: center;\r\n\r\n  img {\r\n    width: 100%;\r\n    padding: 1rem 0.5rem;\r\n    display: block;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  mat-card-actions {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n\r\n    a {\r\n      margin: 0.5rem 0 0;\r\n      width: 100%;\r\n      background-color: var(--dim-white);\r\n    }\r\n  }\r\n\r\n  h1 {\r\n    font-size: 250%;\r\n    text-align: center;\r\n    color: var(--text-color);\r\n  }\r\n  \r\n  div.title {\r\n    width: 100%;\r\n    padding: 0 !important;\r\n    margin: 1rem 0;\r\n    text-align: center;\r\n    color: var(--text-color);\r\n\r\n    h2{\r\n      color: white;\r\n      font-size: 1.5rem;\r\n      padding: 1.1rem;\r\n      display: inline-block;\r\n      margin: 0;\r\n      background-color: var(--dark-blue);\r\n      border-radius: 1rem;\r\n    }\r\n  }\r\n\r\n  div.sub-container{\r\n    width: 100%;\r\n    border-radius: 0.5rem;\r\n    padding: 1rem !important;\r\n    background-color: var(--accent-back);\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  ::ng-deep .mat-card-header-text {\r\n    width: 100%;\r\n  }\r\n\r\n  mat-card-header {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n\r\n// Media query za site uredi pogolemi od 1280px (lg i xl uredi)\r\n@media only screen and (min-width: 1280px) {\r\n\r\n  .fxFlex-25-33md-50sm-100xs {\r\n\r\n      flex: 1 1 25%;\r\n      max-width: 25%;\r\n      box-sizing: border-box;\r\n  }\r\n}\r\n\r\n\r\n// Media query za site uredi pomali od 1280px i pogolemi od 960px (md uredi)\r\n@media only screen and (max-width: 1279px) and (min-width:960) {\r\n\r\n  .fxFlex-25-33md-50sm-100xs {\r\n\r\n      flex: 1 1 33%;\r\n      max-width: 33%;\r\n      box-sizing: border-box;\r\n  }\r\n}\r\n\r\n\r\n\r\n// Media query za site uredi pomali od 960px i pogolemi od 600px (sm uredi)\r\n@media only screen and (max-width: 959px) and (min-width:600px) {\r\n\r\n  .fxFlex-25-33md-50sm-100xs {\r\n\r\n      flex: 1 1 50%;\r\n      max-width: 50%;\r\n      box-sizing: border-box;\r\n  }\r\n}\r\n\r\n\r\n// Media query za site uredi pomali od 600px (xs uredi)\r\n@media only screen and (max-width: 599px) {\r\n\r\n  .fxFlex-25-33md-50sm-100xs {\r\n\r\n      flex: 1 1 100%;\r\n      max-width: 100%;\r\n      box-sizing: border-box;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
